<template>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
created() {
       this.itemLink =  `warehouse/names/${this.id}/features`;
      this.setLink = `warehouse/names/${this.id}/features`;
},
methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "feature",
      fields: [
           {
              label: "Название",
              key: "title",
              type: "field",
              textType: "text", 
              isMultiLang:true
            },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_feature",
      itemLink: "warehouse/features",
      setLink: "warehouse/features",
   columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        {
          key: "title",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
    
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
